import React from "react";
import PropTypes from "prop-types";
import { Avatar, Flex, Icon } from "@evertrue/et-components";
import classNames from "classnames";
import { useETCachedUserById } from "../contexts/et-user-context";
import { useChatDependencyContext } from "../contexts/chat-dependency-context";

const AVATAR_WIDTH = 40;
const AdminTag = props => <Icon className="chat-contact-card--admin-tag" icon="admin" title="user is Admin" />;
const ChatEtUserCard = ({ className, userId, hideName, children, avatarClassName }) => {
  const { user = {} } = useETCachedUserById(userId);
  const { oid, app } = useChatDependencyContext();
  // this user is from different endpoint that normal (b/c of new photo_url so can't use client-decorator)
  const is_volunteer =
    user.roles && user.roles.find(role => role.organization_id == oid && role.name.match(/volunteer/i));

  const show_vms_tag = app !== "vms" && is_volunteer;
  const show_admin_tag = app === "vms" && !is_volunteer;
  return (
    <Flex className={classNames("chat-contact-card", className)} alignItems="center">
      <Avatar url={user.user_profile_picture_url} name={user.name} className={avatarClassName} width={AVATAR_WIDTH} />
      <div className="chat-contact-card--name">
        <span>
          {user.name || "Unknown user"}
          {show_vms_tag && (
            <Icon icon="volunteertag" title="user is a volunteer" className="chat-contact-card--vms-tag" />
          )}
          {show_admin_tag && <AdminTag />}
        </span>
        {children}
      </div>
    </Flex>
  );
};

ChatEtUserCard.propTypes = {
  className: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  hideName: PropTypes.bool,
  children: PropTypes.any,
};

export default ChatEtUserCard;
